import React from "react";
import styled from "styled-components";

const ErrorDiv = styled.div`
  display: block;
  padding: 0.8rem 0.6rem;
  font-size: 0.85em;
  color: #ffffff;
  background-color: #dc3545;
`;

export const Error = (props: any) => {
  return (
    <ErrorDiv className={props.className ? props.className : undefined} style={{ borderRadius: '30px' }}>
      {props.children}
    </ErrorDiv>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/form/modules/Error.tsx